import { render } from "./WorkstreamHeader.vue?vue&type=template&id=39517c2d&scoped=true"
import script from "./WorkstreamHeader.vue?vue&type=script&lang=js"
export * from "./WorkstreamHeader.vue?vue&type=script&lang=js"

import "./WorkstreamHeader.vue?vue&type=style&index=0&id=39517c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39517c2d"]])

export default __exports__